import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, withQuery, money } from '../api.js';
import { Pager } from './Products.jsx';
import { useAuth } from '../App.jsx';

const PAGE = 100;

const TYPE_LABEL = {
  client: 'Клиент',
  supplier: 'Доставчик',
  both: 'Клиент и доставчик',
  agent: 'Агент',
  other: 'Друг',
};

export default function Partners() {
  const { user } = useAuth();
  // Спрените са скрити по подразбиране — те са спрени точно за да не
  // замърсяват списъка. Отметката е единственият път обратно до тях,
  // когато трябва да бъдат пуснати.
  const [filters, setFilters] = useState({ q: '', type: '', activeOnly: true });
  const [offset, setOffset] = useState(0);
  const [data, setData] = useState({ items: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(true);
      api.get(withQuery('/api/partners', {
        q: filters.q,
        type: filters.type,
        // `withQuery` подминава `false`, а точно то трябва да стигне до
        // сървъра — иначе се прилага подразбиращото се „само активните".
        activeOnly: filters.activeOnly ? undefined : 'false',
        limit: PAGE,
        offset,
      }))
        .then(setData)
        .catch((err) => setError(err.message))
        .finally(() => setLoading(false));
    }, filters.q ? 250 : 0);
    return () => clearTimeout(timer);
  }, [filters, offset]);

  function change(patch) {
    setOffset(0);
    setFilters((f) => ({ ...f, ...patch }));
  }

  return (
    <>
      <div className="page-head">
        <h1>Контрагенти</h1>
        <div className="spacer" />
        {user.role !== 'auditor' && (
          <Link to="/partners/new"><button className="primary">+ Нов контрагент</button></Link>
        )}
      </div>

      {error && <div className="error">{error}</div>}

      <div className="toolbar">
        <label className="field">
          Търсене
          <input
            type="search"
            autoComplete="off"
            placeholder="име, ЕИК, ДДС номер или телефон"
            value={filters.q}
            onChange={(e) => change({ q: e.target.value })}
          />
        </label>
        <label className="field">
          Вид
          <select value={filters.type} onChange={(e) => change({ type: e.target.value })}>
            <option value="">всички</option>
            <option value="client">клиенти</option>
            <option value="supplier">доставчици</option>
            <option value="agent">агенти</option>
          </select>
        </label>
        <label style={{ display: 'flex', gap: 6, alignItems: 'center', alignSelf: 'end',
          paddingBottom: 8 }}>
          <input
            type="checkbox"
            checked={!filters.activeOnly}
            onChange={(e) => change({ activeOnly: !e.target.checked })}
          />
          показвай и спрените
        </label>
      </div>

      <div className="card">
        <div className="table-wrap">
          <table className="compact">
            <thead>
              <tr>
                <th>Наименование</th>
                <th>Вид</th>
                <th>ЕИК</th>
                <th>ДДС номер</th>
                <th>Град</th>
                <th>Телефон</th>
                <th className="num">Кредитен лимит</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((p) => (
                <tr key={p.id}>
                  <td>
                    <Link to={`/partners/${p.id}`}>{p.name}</Link>
                    {!p.is_active && <span className="badge muted" style={{ marginLeft: 6 }}>неактивен</span>}
                  </td>
                  <td className="muted">{TYPE_LABEL[p.type] ?? p.type}</td>
                  <td className="muted">{p.eik ?? '—'}</td>
                  <td className="muted">
                    {p.vat_number ?? '—'}
                    {p.is_vat_registered ? <span className="badge ok" style={{ marginLeft: 6 }}>рег.</span> : null}
                  </td>
                  <td className="muted">{p.city ?? '—'}</td>
                  <td className="muted">{p.phone ?? '—'}</td>
                  <td className="num">
                    {Number(p.credit_limit) > 0 ? money(p.credit_limit) : <span className="muted">—</span>}
                  </td>
                </tr>
              ))}
              {!loading && data.items.length === 0 && (
                <tr><td colSpan={7} className="empty">Няма намерени контрагенти</td></tr>
              )}
            </tbody>
          </table>
        </div>
        <Pager total={data.total} offset={offset} setOffset={setOffset} loading={loading} page={PAGE} />
      </div>
    </>
  );
}
